import React, { useRef, useEffect } from "react";
import JKPromotors from "./jkPromotors";
import KJPromotors from "./kjPromotors";
import Shens from "./shens";
import LakSkin from "./lakSkin";
import JMSH from "./jsahospitals";
import { useParams } from "react-router-dom";

const GroupOfCompanies = () => {
  const jkPromotors = useRef(null);
  const kjPromotors = useRef(null);
  const shensHospital = useRef(null);
  const lakSkinClinic = useRef(null);
  const jsaHospital = useRef(null); // renamed for clarity

  const { id } = useParams();

  const getRefByName = (refName) => {
    switch (refName) {
      case "jk-promotors":
        return jkPromotors;
      case "kj-promotors":
        return kjPromotors;
      case "shens-hospital":
        return shensHospital;
      case "lak-skin-clinic":
        return lakSkinClinic;
      case "jsa-hospital":
        return jsaHospital;
      default:
        return null;
    }
  };

  useEffect(() => {
    const ref = getRefByName(id);
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [id]);

  return (
    <div className="container">
      <JKPromotors ref={jkPromotors} />
      <KJPromotors ref={kjPromotors} />
      <Shens ref={shensHospital} />
      <LakSkin ref={lakSkinClinic} />
      <JMSH ref={jsaHospital} /> {/* FIXED */}
    </div>
  );
};

export default GroupOfCompanies;